export const dropDownMenuProps = {
	PaperProps: {
		style: {
			maxHeight: 250,
            maxWidth: 250,
		},
	},
};


/**
 * A type definition for the function that handles Web Worker messages.
 */
type WorkerCallback = (event: MessageEvent) => void;

/**
 * Creates a Web Worker that sends a message at regular intervals.
 * @param callback - The function to call when the Web Worker sends a message.
 * @param interval - The interval in milliseconds for the Web Worker to send messages.
 * @returns An object with a `stop` method to terminate the Web Worker.
 */
export function createWorkerInterval(callback: WorkerCallback, interval: number) {
  const blobContent = `setInterval(() => postMessage(0), ${interval});`;
  const blob = new Blob([blobContent], { type: 'application/javascript' });
  const workerScript = URL.createObjectURL(blob);

  const worker = new Worker(workerScript);

  // Set the callback function for the Web Worker
  worker.onmessage = callback;

  // Return an object with a `stop` method to terminate the Web Worker
  return {
    stop: () => {
      worker.terminate(); // Clean up the Web Worker
      URL.revokeObjectURL(workerScript); // Release the URL resources
    },
  };
}